// src/stores/cars-store.js
import { defineStore } from "pinia";
import { httpRequest } from "@/services/api";
import { showAlert } from "@/composables/useAlert";

export const useCarsStore = defineStore("cars", {
  state: () => ({
    cars: [],
    isLoading: false,
    filters: {
      search: "",
      gear: "",
      year_from: "",
      year_to: "",
      price_from: "",
      price_to: "",
      brand_name: "",
      model_name: "",
      fuel_type: "",
      rent_or_sale: "sale", // default
      pageSize: -1,
    },
  }),

  actions: {
    async fetchCars(customFilters = {}) {
      this.isLoading = true;
      try {
        const params = { ...this.filters, ...customFilters };
        console.log("Fetching cars with filters:", params);

        // ✅ نجهز الـ URLSearchParams
        const searchParams = new URLSearchParams();

        for (const key in params) {
          const value = params[key];
          if (Array.isArray(value)) {
            // لو array نخليهم key[]=val1&key[]=val2
            value.forEach(v => {
              searchParams.append(`${key}[]`, v.toString());
            });
          } else if (value !== "" && value !== null && value !== undefined) {
            searchParams.append(key, value.toString());
          }
        }

        const query = searchParams.toString();

        const res = await httpRequest(`/cars?${query}`, {
          method: "GET",
        });

        this.cars = res.data || [];
        console.log("Cars:", this.cars);
      } catch (error) {
        showAlert(
          error.response?.data?.message || "حدث خطأ أثناء جلب السيارات",
          "error"
        );
      } finally {
        this.isLoading = false;
      }
    },

    setFilter(key, value) {
      this.filters[key] = value;
    },

    resetFilters() {
      this.filters = {
        search: "",
        gear: "",
        year_from: "",
        year_to: "",
        price_from: "",
        price_to: "",
        brand_name: "",
        model_name: "",
        fuel_type: "",
        rent_or_sale: "sale",
        pageSize: -1,
      };
    },
  },
});
